module.exports = __webpack_public_path__ + "img/dttp.e21d75d1.png";